import { Col } from 'antd';
import Card from 'antd/es/card/Card';
import React, { Component, ReactNode } from 'react';
import { AppContext, AppContextValue } from '../../../theme/AppContextProvider';

interface IPropsChatWrapp {
  children: ReactNode;
  usersOnline: number;
}

class _ChatWrapp extends Component<IPropsChatWrapp> {
  static contextType = AppContext;
  render() {
    const { isMobile } = this.context as AppContextValue;

    if (isMobile) {
      return <Col style={{ marginInline: 10 }}>{this.props.children}</Col>;
    }

    return (
      <Card
        bordered={false}
        title={`Мини чат (Oнлайн: ${this.props.usersOnline})`}
        style={{ marginBottom: 8, padding: 0 }}
      >
        {this.props.children}
      </Card>
    );
  }
}

export const ChatWrapp = _ChatWrapp;
